module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/assets/plugins/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/plugins/fonts/glyphicons-halflings-regular.svg
// module chunks = styles